import React, { useContext } from 'react';
import {
  linkedSubmissions,
  linkedSubmissionsForMailer,
} from '../submissions/constants/submissionShow';
import { Link } from 'react-router-dom';
import { SubmissionContext } from '../../hooks/Contexts';

const LinkedMailerInfo = ({ batch, detectedForms, subId, groupData }) => {
  // SubmissionShow page passes group and sub info through Context
  // GlobalSearch page passes group and sub info directly as props (data fetched on mailer select)
  const subContext = useContext(SubmissionContext);
  const group = groupData || subContext?.groupState;
  const submissionID = subId || subContext?.submission?.id;

  const linkedSubs =
    group && submissionID ? linkedSubmissions(submissionID, group) : [];
  const formLinkData = linkedSubs
    ? linkedSubmissionsForMailer(detectedForms, linkedSubs)
    : null;

  return (
    <div className='multi-form-mailer-notice'>
      <h4>
        This is a multi-form mailer that pulls data from the following
        additional forms:
      </h4>
      <ul>
        {batch ? (
          <>
            {detectedForms.map((form) => (
              <li key={`linked-form-${form.id}`}>{form.name}</li>
            ))}
          </>
        ) : (
          <>
            {formLinkData.linkedFormsPresent.length > 0 &&
              formLinkData.linkedFormsPresent.map((form) => (
                <li key={`mailable-form-${form.id}`}>{form.name}</li>
              ))}
            {formLinkData.linkedFormsMissing.length > 0 || group
              ? formLinkData.linkedFormsMissing.map((form) => (
                  <li key={`missing-form-${form.id}`} className='highlight'>
                    {form.name} <i>(Missing linked submission)</i>
                  </li>
                ))
              : detectedForms.map((form) => (
                  <li key={`missing-form-${form.id}`} className='highlight'>
                    {form.name} <i>(Missing linked submission)</i>
                  </li>
                ))}
          </>
        )}
      </ul>

      {batch ? (
        <>
          <hr />
          <div>
            <p>
              <b className='large-red-txt'>Proceed with caution!</b>
            </p>
            <p>
              <b>Although batch emailing for this mailer is possible...</b> it
              is generally recommended to mail multi-form mailers from the
              individual submission level to ensure accurate data targeting.
            </p>
            <p>
              <b>If you need to proceed...</b> it is highly recommended that you
              ensure all of the listed submissions are linked appropriately in
              order to pull the correct data for each email.
            </p>
          </div>
        </>
      ) : (
        <>
          <h4>
            This mailer can pull data from the linked submission(s) listed
            below.
          </h4>
          {formLinkData.linkedWillMail?.length ? (
            <div className='linked-subs-table-wrapper'>
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Form</th>
                    <th>Container</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>

                <tbody>
                  {formLinkData.linkedWillMail.map((linked) => (
                    <tr
                      id={`linked-${linked.submission_id}`}
                      key={`linked-mailable-${linked.submission_id}`}
                      className={linked.disabled ? 'current ignore-hover' : ''}
                    >
                      <td className='no-pointer'>
                        {linked.submission_id}

                        {linked.isParent && (
                          <>
                            &nbsp;
                            <i
                              className='fa-solid fa-star'
                              title='Parent Submission'
                            />
                          </>
                        )}
                      </td>
                      <td className='no-pointer'>{linked.form.name}</td>
                      <td className='no-pointer'>{linked.container_name}</td>
                      <td className='controls inline no-pointer'>
                        <Link
                          target='_blank'
                          to={`/manage/submissions/${linked.submission_id}`}
                        >
                          <i
                            className='fa-solid fa-up-right-from-square'
                            title='Open in new tab'
                          ></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <strong className='large-red-txt'>
              No linked submissions found for this mailer!
            </strong>
          )}
        </>
      )}
    </div>
  );
};

export default LinkedMailerInfo;
